import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

import { BaseField, DollarField, NumberField } from '../../fields';

export const ticketIdDataSelector = (data) => {
  return data.ticket.id;
};

export const ticketVariablesDataSelector = (data) => {
  const { ticket } = data;

  return {
    billingHours: ticket.billing_hours,
    billingRevenue: ticket.billing_revenue,
    supplementalInformation: ticket.supplemental_info,
  };
};

export const formValuesToInput = (values) => {
  return {
    billing_revenue: values.billingRevenue,
    billing_hours: parseFloat(values.billingHours),
    supplemental_info: values.supplementalInformation,
  };
};


export const validate = (values) => {
  const errors = {};

  if (Number.isNaN(values.billingRevenue)
    || values.billingRevenue === null
    || values.billingRevenue === undefined) {
    errors.billingRevenue = 'Required';
  }
  return errors;
};


const TicketVariables = (props) => {
  const { disabled, showBillingHours, workedHoursEqualsBilling } = props;

  const highlightColor = (workedHoursEqualsBilling || workedHoursEqualsBilling === null) ? '' : 'yellow';
  return (
    <div>
      <DollarField
        componentProps={{ disabled }}
        name="billingRevenue"
        label="Net Revenue"
      />
      {showBillingHours && (
        <div style={{ backgroundColor: highlightColor }}>
          <NumberField
            componentProps={{ disabled }}
            name="billingHours"
            label="Billing Hours"
          />
        </div>
      )}
      <BaseField
        componentProps={{ disabled }}
        name="supplementalInformation"
        componentClass="textarea"
        label="Supplemental Information"
      />
    </div>
  );
};


TicketVariables.propTypes = exact({
  disabled: PropTypes.bool.isRequired,
  showBillingHours: PropTypes.bool.isRequired,
  workedHoursEqualsBilling: PropTypes.bool,
});

TicketVariables.defaultProps = {
  workedHoursEqualsBilling: false,
};

export default TicketVariables;
